import * as React from 'react';


const ForDevelopers = () => (
    <div className="container">
        <div className="row">
            <div className="col-md-12 col-lg-12 col-sm-12">
                <h1>Para Desarrolladores</h1>
            </div>
            <div className="col-md-12 col-lg-12 col-sm-12">
                <p>Eres desarrollador y quieres realizar b&uacute;squedas desde tu sistema? Usa el API REST</p>
                <p style={{ marginTop: '10px', padding: '10px', backgroundColor: '#e7f3ff', border: '1px solid #2196F3', borderRadius: '4px' }}>
                    <strong>&#128640; El API est&aacute; disponible p&uacute;blicamente:</strong> Puedes usar este API desde cualquier lugar, desde tu aplicaci&oacute;n web, m&oacute;vil, servidor, o cualquier entorno que pueda realizar peticiones HTTP. No requiere autenticaci&oacute;n ni credenciales especiales.
                </p>
            </div>
            <div className="col-md-12 col-lg-12 col-sm-12">
                <h2>Ejemplo con JavaScript</h2>
                <p>Aqu&iacute; te mostramos c&oacute;mo consumir el API usando JavaScript puro (vanilla JavaScript). Este ejemplo utiliza la API Fetch para realizar la petici&oacute;n y muestra el resultado en la consola del navegador.</p>
                <fieldset>
                    <legend>C&oacute;digo JavaScript</legend>
                    <section>
                        <pre>
                            <code>{`function GetBlackListData(rfc) {
    const requestOptions = {
        method: "GET",
        redirect: "follow"
    };

    console.log('GetBlackListData: starting fetch for RFC:', rfc);
    
    fetch(\`https://lalistanegradelsat.com.mx/api/blacklist/\${rfc}\`, requestOptions)
        .then((response) => {
            console.log('GetBlackListData: response status', response.status);
            if (!response.ok) {
                throw new Error(response.status + ' ' + response.statusText);
            }
            return response.text();
        })
        .then((result) => {
            console.log('GetBlackListData: raw result', result);
            
            // Parse and format JSON response
            try {
                if (result === 'null' || result.trim() === '') {
                    console.log('RFC not found in blacklist');
                    return null;
                } else {
                    const jsonData = JSON.parse(result);
                    console.log('GetBlackListData: parsed JSON', jsonData);
                    return jsonData;
                }
            } catch (parseError) {
                console.log('GetBlackListData: result is not JSON, displaying as text');
                console.log(result);
                return result;
            }
        })
        .catch((error) => {
            console.error('GetBlackListData: error', error);
            throw error;
        });
}

// Ejemplo de uso:
GetBlackListData('APR111208G63');`}</code>
                        </pre>
                    </section>
                </fieldset>
                <p style={{ marginTop: '10px', fontStyle: 'italic' }}>
                    Nota: Abre la consola del navegador (F12) para ver los mensajes de log y el resultado de la petici&oacute;n.
                </p>
            </div>
            <hr/>
            <div className="col-md-12 col-lg-12 col-sm-12">
                <h2>REST</h2>
                <fieldset>
                    <legend>EndPoint</legend>
                    <section>
                        <code>
                            HTTP:GET lalistanegradelsat.com.mx/api/blacklist/AAA091014835 <br />
                        </code>
                    </section>
                </fieldset>
                <fieldset>
                    <legend>Response RFC Encontrado</legend>
                    <section>
                        <pre>
                            <code>{`{
    "razonSocial": "APRONEG, S.A. DE C.V.",
    "rfc": "APR111208G63",
    "estatus": "Definitivo",
    "detalle": {
        "searchDate": "09/23/2021",
        "comments": "Información actualizada al 17 de septiembre de 2021 - test"
    },
    "numOficioPresuntoSAT": "500-05-2018-13380 de fecha 30 de abril de 2018",
    "fechaOficioPresuntoSAT": "0001-01-01T00:00:00",
    "numOficioPresuntoDOF": "500-05-2018-13380 de fecha 30 de abril de 2018",
    "fechaOficioPresuntoDOF": "0001-01-01T00:00:00",
    "numOficioDesvirtuadoSAT": "",
    "fechaOficioDesvirtuadoSAT": "0001-01-01T00:00:00",
    "fechaOficioDesvirtuadoDOF": "0001-01-01T00:00:00",
    "numOficioDefinitivoSAT": "",
    "fechaOficioDefinitivoSAT": "0001-01-01T00:00:00",
    "fechaOficioDefinitivoDOF": "0001-01-01T00:00:00",
    "numOficioSentenciaFavorableSAT": "500-05-2018-29779 de fecha 17 de octubre de 2018",
    "fechaOficioSentenciaFavorableSAT": "0001-01-01T00:00:00",
    "numOficioSentenciaFavortableDOF": "",
    "fechaOficioSentenciaFavorableDOF": "0001-01-01T00:00:00"
}`}</code>
                        </pre>
                    </section>
                </fieldset>
                <fieldset>
                    <legend>Response RFC No Encontrado</legend>
                    <section>
                        <pre>
                            <code>
                                null
                            </code>
                        </pre>
                    </section>
                </fieldset>
                <fieldset>
                    <legend>Bad Request</legend>
                    <section>
                        <pre>
                            <code>{`{
    "messages": [
        "El RFC enviado no es válido",
        "Otros mensajes..."
    ]
}`}</code>
                        </pre>
                    </section>
                </fieldset>
            </div>
        </div>
    </div>
);

export default ForDevelopers;